import { DrawerCommon } from '../../Shared/Drawer/DrawerCommon';
import DrawerCalendarSchedule from './DrawerCalendarSchedule/DrawerCalendarSchedule';

interface Props {
    isOpen: boolean;
    toggleCloseHandler: () => void;
}

export default function DrawerOpenCalenderSchedule({ isOpen, toggleCloseHandler }: Props) {
    return (
        <DrawerCommon
            open={isOpen}
            handleOnClose={toggleCloseHandler}
            title="Schedule Calendar Event"
        >
            <DrawerCalendarSchedule onCloseHandler={toggleCloseHandler} />
        </DrawerCommon>
    );
}
